


import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { loginSliceValue } from "../../redux/reducers/loginSlice";
import { useState } from "react";

const useInactivatePatient = () => {
  const { userDetails } = useSelector(loginSliceValue);
  const [inactivatedPatientLoading, setInactivatedPatientLoading] = useState(false);

  const inactivatePatient = async ({
    patientId,
  }: {
    patientId: string;
 
  }) => {
    setInactivatedPatientLoading(true);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/rtm/patient/inactivate?patientId=${patientId} `,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + userDetails.token,
          },
        }
      );

      if (response?.status === 200) {
        toast.success(response.data.message);
        return response;
      } else {
        toast.error('Failed to activate patient');
        return null;
      }
    } catch (error) {
      toast.error('Something went wrong while updating status');
      return null;
    } finally {
      setInactivatedPatientLoading(false);
    }
  };

  return { inactivatePatient, inactivatedPatientLoading };
};

export default useInactivatePatient;
